/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MakeupCancellationRequest
 */
export interface MakeupCancellationRequest {
    /**
     * 
     * @type {string}
     * @memberof MakeupCancellationRequest
     */
    cancellationReason: string;
}

/**
 * Check if a given object implements the MakeupCancellationRequest interface.
 */
export function instanceOfMakeupCancellationRequest(value: object): value is MakeupCancellationRequest {
    if (!('cancellationReason' in value) || value['cancellationReason'] === undefined) return false;
    return true;
}

export function MakeupCancellationRequestFromJSON(json: any): MakeupCancellationRequest {
    return MakeupCancellationRequestFromJSONTyped(json, false);
}

export function MakeupCancellationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MakeupCancellationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'cancellationReason': json['cancellationReason'],
    };
}

export function MakeupCancellationRequestToJSON(json: any): MakeupCancellationRequest {
    return MakeupCancellationRequestToJSONTyped(json, false);
}

export function MakeupCancellationRequestToJSONTyped(value?: MakeupCancellationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cancellationReason': value['cancellationReason'],
    };
}

